import { Colors } from '@/common/colors/colors';
import Table from '@/common/components/Table';
import React from 'react';
import { TableWrapper } from '../../SerpMonitoring.styles';
import Icon from '@/common/components/Icon';

const SerpMonitoringTable = ({
	configs,
	setShow,
	setSelectedConfig,
	onGenerate,
}) => {
	const headers = ['No.', 'Product', 'Market', 'Actions'];
	const raws = configs.map((config, index) => {
		const productName = config.product?.name;
		const marketName = config.market?.name || config.market?.short;

		return (
			<tr key={config._id}>
				<td>{index + 1}</td>
				<td>{productName}</td>
				<td>{marketName}</td>
				<td>
					<Icon
						onClick={() => {
							setShow(true);
							setSelectedConfig(config);
						}}
						name='edit'
						color={Colors.darkBlue}
						style={{ marginRight: '10px' }}
					/>
					<Icon
						onClick={() =>
							onGenerate({
								productId: config.product?._id,
								marketId: config.market?._id,
							})
						}
						name='sync'
						color={Colors.darkBlue}
					/>
				</td>
			</tr>
		);
	});

	return (
		<TableWrapper>
			<Table
				stickyHeader
				className='styled-table'
				headers={headers}
				raws={raws}
			/>
		</TableWrapper>
	);
};

export default SerpMonitoringTable;
